import { useMemo } from 'react'

/** @type {import('Simple/types.js').useDataTransform} */
export default function useDataTransform(props, data) {
  return useMemo(() => {
    if (!data) return data

    return data.map(item => ({
      id: item.appointment_type._id,
      text: item.full_name_computed,
    }))
  }, [data])
}
